import { Map as ImmutableMap } from 'immutable';
import PortalMetaCategoryIds from '../enums/PortalMetaCategoryIds';
const getCategoryId = category => {
  if (category in PortalMetaCategoryIds) {
    return PortalMetaCategoryIds[category];
  }
  return null;
};
export const getCategoryName = categoryId => Object.keys(PortalMetaCategoryIds).find(category => getCategoryId(category) === categoryId) || null;
export const getCategoryValues = portalMetaList => ImmutableMap(portalMetaList.filter(item => Object.values(PortalMetaCategoryIds).includes(item.get('category'))).map(item => [getCategoryName(item.get('category')), item.get('categoryValue')]));